import React from "react";
import { IconX, IconTrash } from "@tabler/icons-react";

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  isSidebar?: boolean;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Attendance Log",
  message = "Want to Delete this Attendance Log? This action cannot be undone.",
  isSidebar = false,
}) => {
  if (!isOpen) return null;

  if (isSidebar) {
    return (
      <div className="relative rounded-3xl shadow-sm border border-slate-100 flex flex-col overflow-hidden bg-white w-full z-10 animate-in fade-in slide-in-from-right-5 duration-300 p-6 space-y-4">
        <h3 className="text-base font-bold text-[#212121]">{title}</h3>
        <p className="text-xs text-gray-500 font-semibold">{message}</p>
        <div className="flex justify-end gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="border border-gray-200 bg-white hover:bg-gray-50 text-gray-700 font-bold text-xs px-5 py-2 rounded-xl transition cursor-pointer"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="bg-[#F35555] hover:bg-red-600 text-white font-bold text-xs px-5 py-2 rounded-xl transition cursor-pointer border-none"
          >
            Delete
          </button>
        </div>
      </div>
    );
  }

  // Centered overlay popup matching the 4th screenshot
  return (
    <div className="fixed inset-0 z-[99999] bg-black/60 backdrop-blur-xs flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md border border-gray-100 p-6 space-y-4 animate-in fade-in zoom-in-95 duration-200">
        <h3 className="text-base font-bold text-[#212121]">{title}</h3>
        <p className="text-xs text-gray-500 font-medium">{message}</p>
        <div className="flex justify-end gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="border border-gray-300 bg-white hover:bg-gray-50 text-gray-600 font-semibold text-xs px-4 py-2 rounded-xl transition cursor-pointer"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="bg-[#F35555] hover:bg-red-600 text-white font-bold text-xs px-4 py-2 rounded-xl transition cursor-pointer border-none"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
